// extracted by mini-css-extract-plugin
export default {"twitterFave":"Fave_twitterFave__g4kDe","faveAni":"Fave_faveAni__3bJtY","faveContainer":"Fave_faveContainer__6Yfu6"};